import { createAction } from 'redux-actions';
import { http } from 'helpers/axios';
import assign from 'lodash/assign';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { BASE_URL } from 'consts';

export const loading = createAction('@@mam/loading');

export const fetchExperiences = createAction(
  '@@mam/fetchExperiences',
  campaignId => dispatch => {
    dispatch(loading());
    return http
      .get(
        `/experiences?query={"campaign":"${campaignId}"}&populate=landingPageZip&populate=landingImage&populate=package&pageSize=1000`
      )
      .then(d => {
        return d;
      })
      .get('data');
  }
);

export const selectExperience = createAction('@@mam/selectExperience');

export const deleteExperience = createAction(
  '@@mam/deleteExperience',
  (campaignId, experienceId) => dispatch => {
    dispatch(loading());
    const response = http.delete(`/experience/${experienceId}`).get('data');
    dispatch(fetchExperiences(campaignId));
    return response;
  }
);

export const experienceAdded = createAction(
  '@@mam/experienceAdded',
  experience => dispatch => {
    if (experience.landingPageZip) {
      return http
        .get(
          `/files?query={"$or": [ { "_id": "${
            experience.landingPageZip
          }" }, { "_id": "${experience.landingImage}" } ]}`
        )
        .get('data')
        .then(data => {
          return assign(experience, {
            landingPageZip: data.docs[0],
            landingImage: data.docs[1],
          });
        });
    } else {
      return Promise.all(
        experience.files.map(file => http.get(`/files/${file}`).get('data'))
      ).then(files => assign(experience, { files }));
    }
  }
);

export const deletePackage = createAction(
  '@@mam/deletePackage',
  experience => dispatch => {
    dispatch(loading());
    return http.delete(`/assets/${experience}`).get('data');
  }
);

export const deleteAsset = createAction(
  '@@mam/deleteAsset',
  experienceId => dispatch => {
    dispatch(loading());
    return http.delete(`/assets/${experienceId}`).get('data');
  }
);

export const updateProgress = createAction('@@mam/updateProgress');

export const downloadFile = createAction(
  '@@mam/downloadFile',
  (fileId, fileName, totalBytes) => (dispatch, getState) => {
    dispatch(loading());

    const download = axios.create({
      baseURL: BASE_URL,
      timeout: 3600000, // 1 hour
      headers: {
        authorization: getState().auth.token,
      },
      onDownloadProgress: progressEvent => {
        let percent = Math.round(
          (progressEvent.loaded * 100) / totalBytes || 100
        );
        // bug
        if (percent === Infinity) {
          percent = 0;
        }
        dispatch(updateProgress(percent));
      },
      responseType: 'blob', // <- if we remove this option, the download file gets corrupted
      xsrfCookieName: '_csrf',
      withCredentials: true,
    });

    return download
      .get(`/files/download/${fileId}`)
      .then(({ data }) => {
        return fileDownload(data, fileName);
      })
      .catch(error => {
        console.log(error);
      });
  }
);

export const updateComplianceStatus = createAction(
  '@@mam/updateComplianceStatus',
  campaignId => dispatch => {
    dispatch(loading());
    return http
      .get(
        `/assets?query={"campaign":"${campaignId}"}&fields=rows&fields=_id&fields=package&fields=status&fields=messages&pageSize=1000`
      )
      .get('data');
  }
);

export const add = createAction('@@mam/add');

export const cancel = createAction('@@mam/cancel');

export const clearMam = createAction('@@mam/clearMam');
